import { n as e } from "./store-CfeUiT2k.js";
import { Fragment as t, jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/components.tsx
var i = "Cannot reach the sign-in service. Retrying.";
function a({ children: a, unavailableText: o }) {
	let { isLoading: s, sessionCheckUnavailable: c } = e();
	return s ? /* @__PURE__ */ r(t, { children: [a, c && /* @__PURE__ */ n("p", {
		role: "status",
		style: {
			position: "fixed",
			left: 0,
			right: 0,
			bottom: "2rem",
			margin: 0,
			textAlign: "center"
		},
		children: o ?? i
	})] }) : null;
}
function o({ children: r }) {
	let { isAuthenticated: i, isLoading: a } = e();
	return a || !i ? null : /* @__PURE__ */ n(t, { children: r });
}
function s({ children: r }) {
	let { isAuthenticated: i, isLoading: a } = e();
	return a || i ? null : /* @__PURE__ */ n(t, { children: r });
}
//#endregion
export { a as AuthLoading, o as Authenticated, s as Unauthenticated };

//# sourceMappingURL=components.mjs.map